import { createApp } from 'vue'

// Libs
import { initYandexMetrika } from 'yandex-metrika-vue3'
import { createYmaps } from 'vue-yandex-maps'
import { vMaska } from 'maska'

// Antd
import { Button, Input } from 'ant-design-vue'
import router from './router'
import store from './store'
import App from './App.vue'

// Styles
import './styles/main.sass'

// Layouts
import LayoutMain from '@/layouts/LayoutMain.vue'
import LayoutBread from '@/layouts/LayoutBread.vue'
import LayoutGuest from '@/layouts/LayoutGuest.vue'
import LayoutUnverified from '@/layouts/LayoutUnverified.vue'

import './registerServiceWorker'

const YANDEX_API_KEY = '0396c4fe-f64d-4c7a-948b-896661369a7a'

const app = createApp(App)

const ymaps = createYmaps({
  apikey: YANDEX_API_KEY,
})

app.directive('maska', vMaska)
app.component('LayoutMain', LayoutMain)
app.component('LayoutGuest', LayoutGuest)
app.component('LayoutBread', LayoutBread)
app.component('LayoutUnverified', LayoutUnverified)
app
  .use(initYandexMetrika, {
    id: '92963011',
    options: {
      defer: true,
      trackLinks: true,
      clickmap: true,
      accurateTrackBounce: true,
      webvisor: true,
      trackHash: true,
    },
    router,
    scriptSrc: 'https://mc.yandex.ru/metrika/tag.js',
    env: process.env.NODE_ENV,
  })
app.use(ymaps)
app.use(Button)
app.use(Input)
app.use(store)
app.use(router)
app.mount('#app')
